import { render, staticRenderFns } from "./VMFieldWrapper.vue?vue&type=template&id=273459e8&lang=pug&"
import script from "./VMFieldWrapper.vue?vue&type=script&lang=js&"
export * from "./VMFieldWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports